import React, { useEffect, useState } from 'react';
import connect from "react-redux/es/components/connect";
import { useNavigate } from "react-router-dom";
import Box from '@mui/system/Box';
import { TextField, Checkbox, Button, Select, MenuItem, OutlinedInput } from '@mui/material';
import { FormLabel, FormControl, FormGroup, FormControlLabel, FormHelperText, Accordion, AccordionSummary, AccordionDetails, IconButton, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { DesktopDatePicker } from "@mui/x-date-pickers";
import { getVFASOList, formatDate, actionGetExecutionList } from "../store/action/RemoteActionSupervisor";
import translate from "../i18n/translate";
import { resetTimout } from "./common/FirebaseSupervisor";

const ExecutionList = (props) => {
    const navigate = useNavigate();
    const [vfaspList, setVfaspList] = useState([]);
    const [searchVfaspID, setSearchVfaspID] = useState(' ');
    const [language, setLanguage] = useState("");
    const [searchField, setSearchField] = useState(0);
    const [searchKeyword, setSearchKeyword] = useState('');
    const [searchBuySellType, setSearchBuySellType] = useState(0);
    const [searchOtcFlag, setSearchOtcFlag] = useState(false);
    const [searchQuantityOperator, setSearchQuantityOperator] = useState(1);
    const [searchQuantity, setSearchQuantity] = useState(0);
    const [searchDateFrom, setSearchDateFrom] = useState(null);
    const [searchDateTo, setSearchDateTo] = useState(null);
    const [executionList, setExecutionList] = useState([]);

    const onClickSearch = () => {
        resetTimout();
        const requestBody = {
            SearchVFASPID: searchVfaspID.trim(),
            SearchField: searchField,
            SearchKeyword: searchKeyword,
            SearchDateFrom: searchDateFrom ? formatDate(searchDateFrom) : '',
            SearchDateTo: searchDateTo ? formatDate(searchDateTo) : '',
            SearchOtcFlag: searchOtcFlag === true ? 1 : 0,
            SearchQuantityOperator: searchQuantityOperator,
            SearchQuantity: searchQuantity,
            SearchBuySellFlag: searchBuySellType
        };
        props.actionGetExecutionList(requestBody);
        setExecutionList([]);
    };

    const handleChange = (e) => {
        resetTimout();
        let eventValue = e.target.value;
        switch (e.target.name) {
            case "id_SearchField":
                eventValue = parseInt(eventValue);
                setSearchField(eventValue);
                if (eventValue === 0) {
                    setSearchKeyword("");
                }
                break;
            case "id_SearchKeyword":
                setSearchKeyword(eventValue);
                break;
            case "id_BuySell":
                setSearchBuySellType(eventValue);
                break;
            case "id_OtcFlag":
                setSearchOtcFlag(e.target.checked);
                break;
            case "id_QuantityOperator":
                setSearchQuantityOperator(eventValue);
                break;
            case "id_Quantity":
                setSearchQuantity(eventValue);
                break;
            case "search-vfasp":
                setSearchVfaspID(eventValue);
                break;
            default:
                console.log(e.target.name);
        }
    };

    const handleDateFromChange = (e) => {
        resetTimout();
        setSearchDateFrom(e);
    };

    const handleDateToChange = (e) => {
        resetTimout();
        setSearchDateTo(e);
    };

    useEffect(() => {
        if (props?.executionList?.length > 0) {
            setExecutionList(props.executionList);
        }
    }, [props.executionList]);

    useEffect(() => {
        setLanguage(localStorage.getItem("locale"));
        const requestBody = {
            SearchField: 0,
            SearchKeyword: ''
        };
        props.actionGetExecutionList(requestBody);
        setVfaspList(getVFASOList());
    }, []);

    return (
        <div className="user-panel">
            <h2 className="user-panel-title">{translate('Menu-ExecutionList')}</h2>

            <Box sx={{ display: 'flex' }}>
                <Accordion sx={{ display: 'nowrap', marginBottom: '10' }}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                        <Typography>{translate('Filters')}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <FormControl required component="fieldset" sx={{ m: 3, width: 160 }} variant="standard">
                            <FormLabel component="legend" required={false}>{translate('Search-CASP')}</FormLabel>
                            <Select style={{ minWidth: 80 }} name="search-vfasp" labelId="vfasp-label" value={searchVfaspID} onChange={handleChange} className="input-item-label" input={<OutlinedInput label={translate('Search-CASP')} />}>
                                <MenuItem value={' '}><em>{translate('Search-All')}</em></MenuItem>
                                {vfaspList?.map((vfasp, index) => {
                                    return <MenuItem key={vfasp.ClientID} value={vfasp.ClientID}>{vfasp.ClientName}</MenuItem>
                                })
                                }
                            </Select>
                        </FormControl>

                        <FormControl required component="fieldset" sx={{ m: 3, width: 250 }} variant="standard">
                            <Select id="id_SearchField" name="id_SearchField" value={searchField} label={translate('SearchField')} onChange={handleChange}>
                                <MenuItem value={0}><em>{translate('Select-SearchField')}</em></MenuItem>
                                <MenuItem value={2}>{translate('TransactionID')}</MenuItem>
                            </Select>
                        </FormControl>
                        <FormControl required component="fieldset" sx={{ m: 3, width: 250 }} variant="standard">
                            <TextField id="id_SearchKeyword" name="id_SearchKeyword" value={searchKeyword} label={translate('SearchKeyword')} variant="outlined" size="small" onChange={handleChange} />
                        </FormControl>

                        <FormControl required component="fieldset" sx={{ m: 3 }} variant="standard">
                            <FormLabel component="legend" required={false}>{translate('Search-BuySell')}</FormLabel>
                            <Select style={{ minWidth: 80 }} id="id_BuySell" name="id_BuySell" labelId="buySell-label" value={searchBuySellType} onChange={handleChange} className="input-item-label" input={<OutlinedInput label={translate('Search-BuySell')} />}>
                                <MenuItem value="0"><em>{translate('Search-All')}</em></MenuItem>
                                <MenuItem value="1">{translate('Buy')}</MenuItem>
                                <MenuItem value="2">{translate('Sell')}</MenuItem>
                            </Select>
                        </FormControl>
                        <FormControl sx={{ m: 3 }} component="fieldset" variant="standard">
                            <FormControlLabel
                                control={
                                    <Checkbox checked={searchOtcFlag} onChange={handleChange} name="id_OtcFlag" />
                                }
                                label={translate('Search-OTC')}
                            />
                        </FormControl>

                        <FormControl required component="fieldset" sx={{ m: 3 }} variant="standard">
                            <FormGroup style={{ maxWidth: 80 }}>
                                <FormLabel component="legend" required={false}>{translate('Search-Quantity')}</FormLabel>
                                <Select id="id_QuantityOperator" name="id_QuantityOperator" labelId="quantityOperator-label" value={searchQuantityOperator} onChange={handleChange} className="input-item-label">
                                    <MenuItem value="1"><em>{'='}</em></MenuItem>
                                    <MenuItem value="2">{'>'}</MenuItem>
                                    <MenuItem value="3">{'<'}</MenuItem>
                                </Select>
                                <TextField variant="outlined" id="id_Quantity" name="id_Quantity" onChange={(e) => setSearchQuantity(e.target.value)} />
                            </FormGroup>
                        </FormControl>

                        <FormControl required component="fieldset" sx={{ m: 3, width: 160 }} variant="standard">
                            <DesktopDatePicker
                                id="id_DateFrom"
                                name="id_DateFrom"
                                label={translate('Search-DateFrom')}
                                inputFormat="yyyy/MM/dd"
                                value={searchDateFrom}
                                onChange={handleDateFromChange}
                                className='input-bordered'
                                renderInput={(params) => <TextField {...params} />}
                            />
                            <DesktopDatePicker
                                id="id_DateTo"
                                name="id_DateTo"
                                label={translate('Search-DateTo')}
                                inputFormat="yyyy/MM/dd"
                                value={searchDateTo}
                                onChange={handleDateToChange}
                                className='input-bordered'
                                renderInput={(params) => <TextField {...params} />}
                            />
                        </FormControl>

                        <FormControl sx={{ m: 3 }} component="fieldset" variant="standard">
                            <Button variant="contained" onClick={() => onClickSearch()}>{translate('btnSearch')}</Button>
                        </FormControl>
                    </AccordionDetails>
                </Accordion>
            </Box>

            <div className="gaps-3x" />
            <table className="adminTable" style={{ width: 1010 }}>
                <tbody>
                    <tr className="adminTR">
                        <th className="adminTH" style={{ width: '10%' }}>{translate('VFASPID')}</th>
                        <th className="adminTH" style={{ width: '35%' }}>{translate('TransactionID')}</th>
                        <th className="adminTH" style={{ width: '15%' }}>{translate('DateTime')}</th>
                        <th className="adminTH" style={{ width: '10%' }}>{translate('BuySell')}</th>
                        <th className="adminTH" style={{ width: '10%' }}>{translate('Tokens')}</th>
                        <th className="adminTH" style={{ width: '10%' }}>{translate('Amount')}</th>
                        <th className="adminTH" style={{ width: '10%' }}>{translate('Commission')}</th>
                    </tr>
                    {executionList?.map((txn, index) => {
                        return <tr className="adminTR" key={txn.AUTORECID}>
                            <td className="adminTD" width='10%' align='center'>{txn.VFASPID}</td>
                            <td className="adminTD" width='35%' align='center'>{txn.TransactionID}</td>
                            <td className="adminTD" width='15%' align='left'>{txn.DateCreated}</td>
                            <td className="adminTD" width='10%' align='right'>
                                <div className={(txn.BuySellFlag === 2 || txn.BuySellFlag === 3 || txn.BuySellFlag === 8 || txn.BuySellFlag === 9) ? 'Message-Red' : 'Message-Blue'}>{txn.BuySellFlag === 5 ? translate('Transaction-Bonus') : (txn.BuySellFlag === 4 || txn.BuySellFlag === 3) ? translate('Transaction-Gift') : (txn.BuySellFlag === 2 || txn.BuySellFlag === 8 || txn.BuySellFlag === 9) ? translate('Transaction-Sell') : translate('Transaction-Buy')}</div>
                            </td>
                            <td className="adminTD" width='10%' align='right'>
                                {txn.Quantity}<br />{txn.CryptoAsset}
                            </td>
                            <td className="adminTD" width='10%' align='right'>
                                {txn.Amount}<br />{txn.Currency === 'BTC' ? translate('Bitcoin') : translate('Euro')}
                            </td>
                            <td className="adminTD" width='10%' align='right'>
                                {txn.CommissionAmount}<br />{translate('Euro')}
                            </td>
                        </tr>
                    })
                    }
                </tbody>
            </table>

            <div className="gaps-2x" />

        </div>

    );
};

const mapStateToProps = state => {
    return {
        executionList: state.remote.executionList
    };
};

export default connect(mapStateToProps, {
    actionGetExecutionList
})(ExecutionList);
